import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { Breadcrumbs, Link, Typography } from '@material-ui/core';
import { context } from '../../../../globalState/GlobalState';
import './css/BreadCrumbs1.css';

const BreadCrumbs1 = (props) => {
    const { links, lastCrumb, marginLeft, marginTop, fontColor } = props;
    const { globalState } = useContext(context);

    return (
        <Breadcrumbs className="alegreya-font-family font-weight-700 breadcrumbs1-container text-uppercase font-size-s" style={{ marginLeft, marginTop, color: fontColor === 'normal' ? globalState.websiteStyles.colors.primaryColor : fontColor }} separator="›" aria-label="breadcrumb">
            {links.map((link) => {
                return (
                    <Link key={link.link} color="inherit" href={link.link}>
                        {link.title}
                    </Link>
                );
            })}
            <Typography className="alegreya-font-family font-weight-700 font-size-s">{lastCrumb}</Typography>
        </Breadcrumbs>
    );
};

BreadCrumbs1.propTypes = {
    links: PropTypes.array.isRequired,
    lastCrumb: PropTypes.string.isRequired,
    marginLeft: PropTypes.string,
    marginTop: PropTypes.string,
    fontColor: PropTypes.string,
};

BreadCrumbs1.defaultProps = {
    marginLeft: '100px',
    marginTop: '280px',
    fontColor: 'normal',
};

export default memo(BreadCrumbs1);
